/**
 * Pass to navigate(..., { state: OUTBOX_POST_GENERATION_NAV_STATE }) after async
 * generation completes so Outbox can refetch (avoids racing the first list load).
 */
export const OUTBOX_POST_GENERATION_NAV_STATE = Object.freeze({ refreshOutbox: true });
